import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { ReactComponent as Logo } from './img/uraniaSmall.svg';
import { ReactComponent as Ucrm } from './icons/ucrm.svg';
import { ReactComponent as IconCurrentTask } from './icons/currentTask.svg';
import { ReactComponent as IconCampaigns } from './icons/campaigns.svg';
import { ReactComponent as IconNewCampaign } from './icons/newCampaign.svg';
import { ReactComponent as IconCampaignDetails } from './icons/campaignDetails.svg';
import { ReactComponent as IconInboundSearch } from './icons/inboundSearch.svg';
import { ReactComponent as IconMyTasks } from './icons/myTasks.svg';
import { ReactComponent as IconConfig } from './icons/config.svg';
import { ReactComponent as IconReport } from './icons/document.svg';
import { ReactComponent as IconSwitch } from './icons/switch.svg';
import { ReactComponent as IconCollapse } from './icons/collapse.svg';
import { ReactComponent as IconExpand } from './icons/expand.svg';
import { Monitor as IconMonitor, ClaroVentas as ClaroVentasIcon, DashboardIcon, ExecIcon  } from './icons/svgIcons';

import SocketActions from './SocketActions';
import './css/Sidebar.css';
import { useSoftphone } from './SoftphoneContext.jsx';

const Sidebar = (props) => {

    const [currentSelectedOption, setCurrentSelectedOption] = useState(2);
    const [sessionData, setSessionData] = useState({});
    const [collapsed, setCollapsed] = useState(JSON.parse(localStorage.getItem('sidebarCollapsed')));
    const [visibleClaroSearchMenu, setVisibleClaroSearchMenu] = useState(false);
    const history = useHistory();
    const { softphoneConnectionStatus } = useSoftphone();

    useEffect(() => {
        if(props.current){
            setCurrentSelectedOption(Number(props.current));  
        }
        setSessionData(JSON.parse(sessionStorage.getItem('sessionData')));

        //collapse

        //theme
        setTimeout(function() {
            if (localStorage.getItem('theme') === 'theme-dark') {
                setTheme('theme-dark');
            } else {
                setTheme('theme-light');
            }
        }, 20); //hack for localstorage time 


        const connectedInboundQueuesString = sessionStorage.getItem("connectedInboundQueues");
        if (connectedInboundQueuesString) {
            const queues = JSON.parse(connectedInboundQueuesString);
            if (queues.find(q => q.name === 'IN_CLARO_ALQUIMIA')){
                setVisibleClaroSearchMenu(true);
            } 
        }
    }, []);


    useEffect(() => {
        if(JSON.parse(localStorage.getItem('sidebarCollapsed'))!== collapsed){
            console.log('🐞DEBUG cambiar en LS');
            localStorage.setItem('sidebarCollapsed',collapsed);
        }
    }, [collapsed]);
    

    const setTheme=(themeName) => {
        localStorage.setItem('theme', themeName);
        document.documentElement.className = themeName;
    }

    const toggleTheme=()=> {
        if (localStorage.getItem('theme') === 'theme-dark') {
            setTheme('theme-light');
        } else {
            setTheme('theme-dark');
        }
    }

    return (
        <div className={collapsed ? 'sidebar collapsed' : 'sidebar'} style={sessionData && sessionData.customStyles ? { backgroundColor: sessionData.customStyles.sidebarBackgroundColor, color: sessionData.customStyles.sidebarColor }:undefined}> 

            <div className={'softphoneStatus ' + softphoneConnectionStatus}></div>
            <SocketActions/>

            {sessionData && sessionData.customStyles ? (
                <img src={sessionData.customStyles.logoUrl} style={{ width: sessionData.customStyles.logoWidth}}/>
            ) : (
                !collapsed?(<Logo className="logo" />):(<Ucrm className="logoSmall" />)
            )}
            
            <ul>
                {(sessionData.profile_code==='EXEC') ? 
                    <li className={(currentSelectedOption === 1) ? 'selected' : null}>
                        <a tooltip={collapsed?'Gestión actual':undefined} tooltip_position='right' className={(!sessionStorage.getItem('currentClient') || sessionStorage.getItem('currentClient')=== "null")?'disabled rel':'rel'} onClick={() => { setCurrentSelectedOption(1); history.push("/" + (JSON.parse(sessionStorage.getItem('currentClient'))).campaignId + "/" + (JSON.parse(sessionStorage.getItem('currentClient'))).clientId);}}><IconCurrentTask/><span>Gestión actual</span></a>
                    </li>
                : null}

                {visibleClaroSearchMenu?(
                    <li className={(currentSelectedOption === 12) ? 'selected' : null}>
                        <a className='rel' tooltip={collapsed ? 'ClaroVentas' : undefined} tooltip_position='right' onClick={() => { setCurrentSelectedOption(10); history.push("/clientsClaroVentas/0"); }}><IconInboundSearch /><span>ClaroVentas</span></a>
                    </li>
                ):null}
                
                {(sessionData.profile_code === 'EXEC' || sessionData.profile_code === 'SUPV') ? (
                    <li className={(currentSelectedOption === 10) ? 'selected' : null}>
                        <a className='rel' tooltip={collapsed?'Búsqueda general':undefined} tooltip_position='right' onClick={() => { setCurrentSelectedOption(10); history.push("/clients");}}><IconInboundSearch/><span>Búsqueda general</span></a>
                    </li>):null
                }

                {(sessionData.profile_code === 'EXEC' || sessionData.profile_code === 'EXEC_CHAT' || sessionData.profile_code === 'EXEC_CHAT_REB') ? (
                    <li className={(currentSelectedOption === 2) ? 'selected' : null}>
                        <a className='rel' tooltip={collapsed?'Campañas':undefined} tooltip_position='right' onClick={() => { setCurrentSelectedOption(2); history.push("/campaigns");}}><IconCampaigns/><span>Campañas</span></a>
                    </li>):null
                }

                {/* {(sessionData.profile_code === 'SUPV') ? (
                    <li className={(currentSelectedOption === 9) ? 'selected' : null}>
                        <a className='rel' tooltip={collapsed?'Adm Campañas':undefined} tooltip_position='right' onClick={() => { setCurrentSelectedOption(9); history.push("/adminCampaigns");}}><IconCampaigns/><span>Adm Campañas</span></a>
                    </li>)
                : null} */}

                {(sessionData.profile_code === 'SUPV') ? 
                    <li className={(currentSelectedOption === 6) ? 'selected' : null}>
                        <a className='rel' tooltip={collapsed?'Nueva campaña':undefined} tooltip_position='right' onClick={() => { setCurrentSelectedOption(6); history.push("/newCampaign"); }}><IconNewCampaign/><span>Nueva campaña</span></a>
                    </li>
                : null}
                
                {(sessionData.profile_code === 'EXEC') ? (
                <li className={(currentSelectedOption === 3) ? 'selected' : null}>
                    <a className={( !props.currentCampaignId) ? 'disabled rel' : 'rel'} tooltip={collapsed?'Detalle campaña':undefined} tooltip_position='right' onClick={() => { setCurrentSelectedOption(3); history.push("/campaign/"+props.currentCampaignId);}}><IconCampaignDetails/><span>Detalle campaña</span></a>
                </li>
                ):null}
                
                {(sessionData.profile_code === 'EXEC') ? 
                <li className={(currentSelectedOption === 4) ? 'selected' : null}>
                    <a className='rel' tooltip={collapsed?'Mis gestiones':undefined} tooltip_position='right' onClick={() => { setCurrentSelectedOption(4); history.push("/tasks");}}><IconMyTasks/><span>Mis gestiones</span></a>
                </li>
                : null}

                {(sessionData.profile_code === 'ADM') ?
                    <li className={(currentSelectedOption === 5) ? 'selected' : null}>
                        <a className='rel' tooltip={collapsed?'Árbol gestión':undefined} tooltip_position='right' onClick={() => { setCurrentSelectedOption(5); history.push("/fields"); }}><IconConfig/><span>Árbol gestión</span></a>
                    </li>
                : null}

                {(sessionData.profile_code === 'ADM' || sessionData.profile_code === 'SUPV') ?
                    <li className={(currentSelectedOption === 7) ? 'selected' : null}>
                        <a className='rel' tooltip={collapsed?'Reportes':undefined} tooltip_position='right' onClick={() => { setCurrentSelectedOption(7); history.push("/reports"); }}><IconReport/><span>Reportes</span></a>
                    </li>
                : null}

                {(sessionData.profile_code === 'SUPV') ? 
                    <li className={(currentSelectedOption === 6) ? 'selected' : null}>
                        <a className='rel' tooltip={collapsed ? 'Nueva campaña CLAROVENTAS' : undefined} tooltip_position='right' onClick={() => { setCurrentSelectedOption(11); history.push("/newClaroVentasCampaign"); }}><ClaroVentasIcon /><span>Nueva Campaña CV</span></a>
                    </li>
                : null}
                
                {(sessionData.profile_code === 'SUPV') ? 
                    <li className={(currentSelectedOption === 6) ? 'selected' : null}>
                        <a className='rel' tooltip={collapsed ? 'Monitor' : undefined} tooltip_position='right' onClick={() => { setCurrentSelectedOption(11); history.push("/monitor2"); }}><IconMonitor/><span>Monitor</span></a>
                    </li>
                : null}

                {(sessionData.profile_code === 'ADM') ?
                    <li className={(currentSelectedOption === 8) ? 'selected' : null}>
                        <a className='rel disabled' tooltip={collapsed?'Registro pagos':undefined} tooltip_position='right' onClick={() => { setCurrentSelectedOption(8); history.push("/payments"); }}><IconConfig/><span>Registro pagos</span></a>
                    </li>
                : null}

                {(sessionData.profile_code === 'ADM') ?
                    <li className={(currentSelectedOption === 10) ? 'selected' : null}>
                        <a className='rel disabled' tooltip={collapsed?'Listas negras':undefined} tooltip_position='right' onClick={() => { setCurrentSelectedOption(10); history.push("/blackLists"); }}><IconConfig/><span>Listas negras</span></a>
                    </li>
                : null}

                {(sessionData.profile_code === 'ADM') ?
                    <li className={(currentSelectedOption === 9) ? 'selected' : null}>
                        <a className='rel disabled' tooltip={collapsed?'Usuarios':undefined} tooltip_position='right' onClick={() => { setCurrentSelectedOption(9); history.push("/users"); }}><IconConfig/><span>Usuarios</span></a>
                    </li>
                : null}

                {(sessionData.profile_code === 'SUPV') ?
                    <li className={(currentSelectedOption === 11) ? 'selected' : null}>
                        <a className='rel' tooltip={collapsed ? 'Usuarios' : undefined} tooltip_position='right' onClick={() => { setCurrentSelectedOption(11); history.push("/hourlyReport"); }}><IconConfig/><span>Reporte horario</span></a>
                    </li>
                : null}

                {(sessionData.profile_code === 'SUPV') ?
                    <li className={(currentSelectedOption === 15) ? 'selected' : null}>
                        <a className='rel' tooltip={collapsed ? 'Ivr Dts' : undefined} tooltip_position='right' onClick={() => { setCurrentSelectedOption(15); history.push("/ivrDts"); }}><DashboardIcon /><span>IVR Dts</span></a>
                    </li>
                : null}

                {(sessionData.profile_code === 'EXEC_CHAT' || sessionData.profile_code === 'EXEC_CHAT_REB') ?
                    <li className={(currentSelectedOption === 13) ? 'selected' : null}>
                        <a className='rel' tooltip={collapsed ? 'Busqueda de chats' : undefined} tooltip_position='right' onClick={() => { setCurrentSelectedOption(13); history.push("/chatReport"); }}><IconInboundSearch /><span>Búsqueda de chats</span></a>
                    </li>
                : null}

                {(sessionData.profile_code === 'EXEC_CHAT_REB' || sessionData.profile_code === 'CONS_CHAT') ?
                    <li className={(currentSelectedOption === 14) ? 'selected' : null}>
                        <a className='rel' tooltip={collapsed ? 'Dashboard chats' : undefined} tooltip_position='right' onClick={() => { setCurrentSelectedOption(14); history.push("/chatDashboard"); }}><DashboardIcon width="22" height="22" /><span>Dashboard chats</span></a>
                    </li>
                : null}


                {(sessionData.profile_code === 'SUPV') ?
                    <li className={(currentSelectedOption === 16) ? 'selected' : null}>
                        <a className='rel' tooltip={collapsed ? 'Creación ejecutivos' : undefined} tooltip_position='right' onClick={() => { setCurrentSelectedOption(16); history.push("/createExecutives"); }}><ExecIcon width="22" height="22" /><span>Creación ejecutivos</span></a>
                    </li>
                : null}


                <li>
                    <a className='rel' tooltip={collapsed?'Modo dia / Noche':undefined} tooltip_position='right' onClick={toggleTheme}><IconSwitch/><span>Modo noche/día</span></a>
                </li>

            </ul>

            
            <a className='toggleCollapse' onClick={()=>setCollapsed(!collapsed)}>{!collapsed?(<IconCollapse/>):(<IconExpand/>)}</a>
        </div>
    );

}

export default Sidebar;